import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { Constants } from "../constants/constants";
import {
  Appointment,
  AppointmentUpdateModel,
  CreateAppointmentRequest,
} from "../models/AppointmentModels";
import { PagedResult } from "../models/PagedModels";

const API_BASE_URL = Constants.API_BASE_URL;

export interface AppointmentListQuery {
  page?: number;
  pageSize?: number;
  from?: string;
  to?: string;
  search?: string;
  uniquePhone?: boolean;
}

export async function getAppointmentsByOrganizationAsync(
  token: string,
  organizationId: string,
  query: AppointmentListQuery = {},
): Promise<ResponseMessage<PagedResult<Appointment>>> {
  const response = await axios.get(
    `${API_BASE_URL}/appointments/organization/${organizationId}`,
    {
      params: {
        page: query.page,
        pageSize: query.pageSize,
        from: query.from,
        to: query.to,
        search: query.search,
        uniquePhone: query.uniquePhone,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function getAppointmentsByClientAsync(
  token: string,
  clientId: string,
): Promise<ResponseMessage<Appointment[]>> {
  const response = await axios.get(
    `${API_BASE_URL}/appointments/client/${clientId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function createAppointmentAsync(
  token: string,
  request: CreateAppointmentRequest,
): Promise<ResponseMessage<Appointment>> {
  const response = await axios.post(`${API_BASE_URL}/appointments`, request, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function updateAppointmentAsync(
  token: string,
  id: string,
  model: AppointmentUpdateModel,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.put(`${API_BASE_URL}/appointments/${id}`, model, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function deleteAppointmentAsync(
  token: string,
  id: string,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.delete(`${API_BASE_URL}/appointments/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}